import AntdDivider from "antd/es/divider";

const Divider = AntdDivider;

export { Divider };
